<script lang="ts">
  type EnabledButtons = {
    isBinButtonEnabled: Boolean;
    isCaixaButtonEnabled: Boolean;
  };

  type ButtonLinks = {
    binLink: string;
    caixaLink: string;
  }

  export let enabledButtons: EnabledButtons;
  export let buttonLinks: ButtonLinks;

  const goToDeepLink = (flavor) => { 
    if(flavor == 'bin') {
      location.assign(buttonLinks.binLink);
    } else {
      location.assign(buttonLinks.caixaLink);
    }
  }

</script>

<main>
  <div class="header-logo">
    <img src="./static/fiserv.svg" alt="Fiserv logo"/>
  </div>
  <div class="content-container">
    <p>Escolha o seu aplicativo para acompanhar os pagamentos:</p>
    <div style="height: 64px;"></div>
    {#if enabledButtons != null && enabledButtons.isBinButtonEnabled}
    <button on:click={() => goToDeepLink('bin')} class="button bin">
      <img src="./static/bin.svg" alt="Bin Logo"/>
    </button>
    {/if}
    {#if  enabledButtons.isCaixaButtonEnabled}
    <button on:click={() => goToDeepLink('caixa')} class="button caixa">
      <img src="./static/azulzinha.svg" alt="Azulzinha Logo" />
    </button>
    {/if}
  </div>
</main>

<style>
  .header-logo {
    background-color: #fff;
    width: 100%;
    min-height: 52px;
    padding: 0;
    margin: 0;
    position: relative;
  }

  .header-logo img {
    position: absolute;
    margin: 0 auto;
    top: 50%;
    left: 50%;
    width: calc(100% -32px);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  main {
    background-color: #f6f6f6;
    height: 100%;
    padding: 0;
    margin: 0;
    text-align: center;
    position: relative;
  }

  .content-container {
    position: absolute;
    margin: 0 auto;
    top: 50%;
    left: 50%;
    width: calc(100% - 32px);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .button {
    background-color: #666;
    border-radius: 2px;
    padding: 10px 0px;
    margin-bottom: 16px;
    width: 100%;
  }

  .bin {
    background-color: #ff6600;
  }

  .caixa {
    background-color: #0066b3;
  }

  p {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #000;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
